const FORM_ERROR_SELECTORS = [
  "#autocomplete-wrapper.error",
  ".form-group.error",
  ".checkbox-item span.error",
  ".checkbox-item div.error",
].join(", ");

function getScrollTarget(errorEl: HTMLElement): HTMLElement {
  return (
    errorEl.closest<HTMLElement>(".autocomplete-address-row") ??
    errorEl.closest<HTMLElement>(".checkbox-row") ??
    errorEl.closest<HTMLElement>(".form-group") ??
    errorEl
  );
}

export function scrollToFirstFormError(
  container?: HTMLElement | null,
  options: ScrollIntoViewOptions = { behavior: "smooth", block: "center" }
): void {
  const root = container ?? document.body;

  const scroll = () => {
    const errorEl = root.querySelector<HTMLElement>(FORM_ERROR_SELECTORS);
    if (!errorEl) return;

    getScrollTarget(errorEl).scrollIntoView(options);
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(scroll);
  });
}
